import { getCategories } from '../../services/CategoryService'
import { getSkills, getAgeRanges, getAllOds } from '../../services/SkillsResource'
import { getAcademicCourses, getAdminAcademicCourses } from '../../services/AcademicGrade'
import { getAllTopics } from '../../services/TopicService'
import { getAllUdls } from '../../services/UdlService'
import { getAllEvaluationMethods } from '../../services/EvaluationMethodService'

export default {
  state: {
    categories: [],
    skills: [],
    ages: [],
    ods: [],
    academicCourses: [],
    resources: [],
    topics: [],
    udls: [],
    evaluationMethods: []
  },

  mutations: {
    setCategories(state, categories) {
      state.categories = categories
    },
    setSkills(state, skills) {
      state.skills = skills
    },
    setAges(state, ages) {
      state.ages = ages
    },
    setOds(state, ods) {
      state.ods = ods
    },
    setAcademicCourses(state, courses) {
      state.academicCourses = courses
    },
    setTopics(state, topics) {
      state.topics = topics
    },
    setUdls(state, udls) {
      state.udls = udls
    },
    setEvaluationMethods(state, methods) {
      state.evaluationMethods = methods
    },
    setResources(state, resources) {
      state.resources = resources
    },
    setLoading(state, { loader, status }) {
      state[`${loader}Loading`] = status
    }
  },

  actions: {
    async hydrateCategories({ commit }) {
      const response = await getCategories()
      commit('setCategories', response.data)
    },
    async hydrateSkills({ commit }) {
      const response = await getSkills()
      commit('setSkills', response.data)
    },
    async hydrateAges({ commit }) {
      const response = await getAgeRanges()
      commit('setAges', response.data)
    },
    async hydrateOds({ commit }) {
      const response = await getAllOds()
      commit('setOds', response.data)
    },
    async hydrateTopics({ commit }) {
      const response = await getAllTopics()
      commit('setTopics', response.data)
    },
    async hydrateAcademicCourses({ commit }, { schoolId, isAdmin }) {
      const response = isAdmin ? await getAdminAcademicCourses(schoolId) : await getAcademicCourses(schoolId)
      commit('setAcademicCourses', response.data)
    },
    async hydrateUdls({ commit }) {
      const response = await getAllUdls()
      commit('setUdls', response.data)
    },
    async hydrateEvaluationMethods({ commit }) {
      const response = await getAllEvaluationMethods()
      commit('setEvaluationMethods', response.data)
    }
  }
}
